import { useMemo } from 'react';
import { Entity } from '@backstage/catalog-model';
import {
  ANNOTATION_VIEW_URL,
  ANNOTATION_EDIT_URL,
  ANNOTATION_LOCATION,
} from '@backstage/catalog-model';
import {
  TECHDOCS_ANNOTATION,
  TECHDOCS_EXTERNAL_ANNOTATION,
} from '@backstage/plugin-techdocs-common';

export interface EntityUrls {
  viewUrl?: string;
  editUrl?: string;
  sourceLocation?: string;
  techdocsLocation?: string;
  techdocsExternalLocation?: string;
  entityLocation?: string;
}

export const useEntityUrls = (entity: Entity): EntityUrls => {
  return useMemo(() => {
    const annotations = entity.metadata.annotations || {};

    return {
      viewUrl: annotations[ANNOTATION_VIEW_URL],
      editUrl: annotations[ANNOTATION_EDIT_URL],
      sourceLocation: annotations[ANNOTATION_LOCATION],
      techdocsLocation: annotations[TECHDOCS_ANNOTATION],
      techdocsExternalLocation: annotations[TECHDOCS_EXTERNAL_ANNOTATION],
      entityLocation: annotations[ANNOTATION_LOCATION],
    };
  }, [entity.metadata.annotations]);
};
